import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { isValidPhoneNumber } from 'libphonenumber-js/min';

export const E164_PHONE_VALIDATOR: ValidatorFn = (
  control: AbstractControl
): ValidationErrors | null => {
  const value = control.value;
  if (value == null || value === '') {
    return null;
  }
  const str = typeof value === 'string' ? value : String(value);
  return isValidPhoneNumber(str) ? null : { invalidPhone: true };
};